<template>
  <div class="" :class="cardGridClasses">
    <router-link :to="movieRouteConfig" id="id-unico-titulo">
      <card type="secondary" shadow hover
        bodyClasses="p-1"
        :class="cardClasses">
        <template>
          <img v-lazy="cover" class="card-img-top" :class="[{'blur': !this.titulo.midias.length && !this.titulo.procuro}]">
          <div class="lazyOverlay">
            <img src="img/tail-spin.svg">
          </div>
          <div class="px-2 py-3 title">
            <strong>{{this.titulo.titulo_traduzido}}</strong><br><small>{{this.titulo.titulo_original}} ({{this.titulo.ano}})</small>
            <p v-html="tituloContent" class="mb-0"></p>
          </div>
        </template>
      </card>
    </router-link>
  </div>
</template>
<script>
import Card from '@/components/Card';

export default {
  name: "movieCard",
  components: {
    Card,
  },
  props: {
    cardGridClasses: {
      type: [String, Object, Array],
      default: "col-6 col-md-4 col-lg-3 mb-4",
      description: "Individual card grid css classes"
    },
    cardClasses: {
      type: [String, Object, Array],
      default: "bg-white border-0",
      description: "Individual card css classes"
    },
    titulo: {
      type: Object
    }
  },
  methods: {
    getUnique(arr, comp) {
      const unique =  arr.map(e => e[comp])
            .map((e, i, final) => final.indexOf(e) === i && i)
            .filter((e) => arr[e]).map(e => arr[e]);
      return unique;
    }
  },
  computed: {
    tituloContent() {
      const media_term = ( this.titulo.seriado == true ) ? 'temporadas' : 'mídias';
      let badge_ultima_atualizacao = ( this.titulo.ultima_atualizacao == null ) ? '' : '<span class="badge badge-secondary left">última atualização: '+this.titulo.ultima_atualizacao+'</span>';
      let badge_procuro = ( this.titulo.procuro == true ) ? '<span class="badge badge-info">procuro esse filme</span>' : '';
      let badge_midias = ( this.titulo.midias.length > 0 ) ? '<span class="badge badge-success">'+media_term+' disponíveis: '+this.titulo.midias.length+'</span>' : '<span class="badge badge-warning">mídia indisponível</span>';
      let midias_information = '<br>';
      const uniqueMidias = this.getUnique(this.titulo.midias,'formato');
      uniqueMidias.forEach(element => {
        midias_information += '<img width="20" height="20" src="img/mediaformat/'+element.formato+'.svg" alt title="'+element.formato+'">&nbsp;';
      });
      badge_midias += midias_information;
      let conhecido_como = ( !this.titulo.outros_titulos ) ? '' : '<p class="aka"><small><strong>Também conhecido como: </strong><br>'+this.titulo.outros_titulos+'</small></p>';
      return badge_ultima_atualizacao+badge_procuro+badge_midias+conhecido_como;
    },
    cover() {
      return this.titulo.cover
    },
    movieRouteConfig() {
      if ( this.titulo.seriado ) {
        return '/seriados/'+this.titulo.id+'/'+this.titulo.slug+'-'+this.titulo.ano
      }else {
        return '/filmes/'+this.titulo.id+'/'+this.titulo.slug+'-'+this.titulo.ano
      }
    }
  },
  created() {
    //console.log(this.titulo.cover);
  },
};
</script>
<style>
  .blur {
    filter: blur(3px) grayscale(100%);
  }
  .aka {
    white-space: pre-wrap; 
    word-wrap: break-word;
    line-height: 1;
    display: block;
    margin-top: 5px;
    margin-bottom: 0;
  }
  .badge.left {
    white-space: normal;
    text-align: left;
  }
  .title strong {
    line-height: 1;
  }
</style>
